<template>
  <main  :class="isBox?'boxPadding':''">
    <tab-header :currentTab="currentTab"/>
    <div class="tab-content" :class="{'section-loading': listAreaLoading}">
      <div class="container-fluid mt-4-5" style="min-height: 500px;">
        <group-related-list
        v-if="status === 'STATUS_GROUP_RELATED_LIST'"
        :status="status"
        @change-status="changeStatus" />

        <all-category-index :status="status" @go-default="goDefault" />
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {commonMixin} from '@/mixins/common'
import GroupRelatedList from './GroupRelated/GroupRelatedList'
import TabHeader from '@/desktop/components/ListsArea/TabHeader';
import AllCategoryIndex from "@/desktop/components/ListsArea/AllCategoryIndex";
import { setListAreaLog } from "@/service";

export default {
  name: 'GroupRelatedIndex',
  mixins: [commonMixin],
  components: {
    GroupRelatedList,
    TabHeader,
    AllCategoryIndex
  },
  computed : {
    ...mapGetters([ 'UserInfo', 'GetCategoryStatus', 'GetSerNoByStatus' ]),
    isBox (){
     //判斷是否為box   this.UserInfo.userType === 'box'
     return this.UserInfo.userType === 'box'
    }
  },
  data () {  //data block layout
    return {
      listAreaLoading: false,
      currentTab: 4,
      status: 'STATUS_GROUP_RELATED_LIST'
    }  
  },
  methods: {
    ...mapActions(["setListAreaSerNo"]),
    changeStatus(status) {
      this.status = status;
      const currentUrlQuery = { ...this.$route.query }
      if( Object.entries(currentUrlQuery).length == 0 ){
        currentUrlQuery.path = status;
        this.$router.replace({
          name: this.$route.name,
          query: currentUrlQuery
        })
      }
    },
    goDefault() {
      this.status = "STATUS_GROUP_RELATED_LIST";
    },
    setLog(serNo) {
      setListAreaLog(this.$store.state.userInfo.id, serNo, "1").then(result => {
        if (result.header && result.header.status == "200") {
          console.log("新增成功");
        } else {
          console.error("新增名單專區log API 錯誤");
        }
      });
    }
  },
  beforeMount() {
    let initStatus = this.$store.state.initCategoryStatus;
    if (initStatus) {
      this.changeStatus(initStatus);
      this.$store.state.initCategoryStatus = "";
    }

    const pathStatus = this.$route.query.path; 
    if(pathStatus){
      if(!initStatus){
        let serNo = this.GetSerNoByStatus(pathStatus)
        this.setListAreaSerNo(serNo)  //  更新流水編到 Vuex
        if (serNo) {
          //this.setLog(serNo); //新增名單專區Log 
          this.status = pathStatus
        }
      }
    }
  },
  mounted () {}
}
</script>
<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>